import React, { createContext, useContext } from 'react';

const AuthContext = createContext(null);

export const UserAuthProvider = ({ children }) => {
  const Login = (token, userId) => {
    localStorage.setItem('token', token);
    localStorage.setItem('userId', userId);
  };

  const Logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.clear();
  };

  ////////////////////////////////////////////////////////////////////////////////
  return <AuthContext.Provider value={{ Login, Logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
